export const config = {
  title: "Greg Rank | Mortgage Loan Officer | Carmel, IN",
  meta: {
    description:
      "Greg Rank, experienced mortgage loan officer serving Carmel, Indiana and surrounding areas. Specializing in home purchase loans, refinancing, FHA, VA, and conventional mortgages with competitive rates and personalized service.",
    keywords: [
      "Greg Rank Mortgage",
      "Indiana Real Estate Loans",
      "Carmel IN Mortgage Lender",
      "Home Loans Carmel",
      "Mortgage Broker Indiana",
      "FHA Loans",
      "VA Loans",
      "Refinancing Indiana",
      "First Time Homebuyer",
      "Conventional Loans"
    ],
    author: "Greg Rank",
    canonicalUrl: "https://www.indianarealestateloans.com/",
  },
  sections: {
    header: {
      businessName: "Greg Rank",
    },
    sectionB: {
      heroTitle: "Your Trusted Mortgage Partner in Indiana",
      heroSubtitle: "Expert Mortgage Solutions for Home Purchases & Refinancing",
      learnAboutText: "Get Pre-Qualified Today",
      phoneNumber: "3176030912",
      phoneLabel: "(317) 603-0912",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1181134074/photo/aerial-view-of-residential-houses-at-autumn-american-neighborhood-suburb-real-estate-drone.jpg?s=612x612&w=0&k=20&c=GmpNoWnRyiBJsabooqGv5k1dY0nNradFSm8LGIoiR18=",
      cardData: [
        {
          title: "Home Purchase Loans",
          description:
            "Competitive rates and flexible programs to help you buy your dream home in Indiana.",
        },
        {
          title: "Refinancing",
          description:
            "Lower your monthly payments or access your home equity with streamlined refinancing options.",
        },
        {
          title: "First-Time Homebuyers",
          description:
            "Specialized programs and guidance for first-time buyers, including low down payment options.",
        },
      ],
      description:
        "Greg Rank is an experienced mortgage loan officer serving Carmel, Indiana and surrounding communities. With a commitment to personalized service and competitive rates, Greg helps clients navigate the home financing process with confidence.",
    },
    sectionC: {
      servicesTitle: "Mortgage Loan Programs",
      servicesDescription:
        "Comprehensive mortgage solutions tailored to your financial goals and homeownership dreams.",
      cards: [
        {
          title: "Conventional Loans",
          description:
            "Traditional mortgage financing with competitive rates for qualified buyers, offering flexible terms and down payment options.",
          imageSrc: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1973&auto=format&fit=crop",
          imageAlt: "Conventional Home Loans",
        },
        {
          title: "FHA & VA Loans",
          description:
            "Government-backed loans with low down payments for first-time buyers and veterans, making homeownership more accessible.",
          imageSrc: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?q=80&w=1996&auto=format&fit=crop",
          imageAlt: "FHA and VA Loans",
        },
        {
          title: "Refinancing Options",
          description:
            "Lower your interest rate, reduce monthly payments, or tap into your home equity with cash-out refinancing solutions.",
          imageSrc: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop",
          imageAlt: "Mortgage Refinancing",
        },
      ],
      otherServicesTitle: "Additional Loan Programs",
      otherServicesList: [
        "Jumbo Loans",
        "USDA Rural Housing Loans",
        "Construction Loans",
        "Adjustable Rate Mortgages (ARM)",
        "Debt Consolidation",
      ],
    },
    sectionD: {
      aboutTitle: "About Greg Rank",
      aboutImage: {
        src: "https://www.indianarealestateloans.com/wp-content/uploads/sites/25439/2025/10/Greg-Rank-2.png",
        alt: "Greg Rank Mortgage Professional",
      },
      aboutText: [
        "Greg Rank is a dedicated mortgage loan officer serving the Carmel, Indiana community and surrounding areas. With extensive knowledge of the local real estate market and a wide range of loan programs, Greg is committed to helping clients find the right mortgage solution for their unique situation.",
        "Whether you're a first-time homebuyer, looking to refinance, or seeking an investment property loan, Greg provides personalized guidance throughout the entire mortgage process. His goal is to make home financing simple, transparent, and stress-free while securing the best possible rates and terms for his clients.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Greg Rank - Mortgage Loan Officer",
      businessName: "Greg Rank - Mortgage Specialist",
      contact: {
        phone: "3176030912",
        phoneLabel: "(317) 603-0912",
        email: "gregrank79@gmail.com",
        website: "https://www.indianarealestateloans.com/",
        address: "1980 E 116th St, #110, Carmel, IN 46032",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "1980 E 116th St, #110, Carmel, IN 46032",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3057.8!2d-86.1180!3d39.9686!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8814ac8e8e8e8e8e%3A0x8e8e8e8e8e8e8e8e!2s1980%20E%20116th%20St%20%23110%2C%20Carmel%2C%20IN%2046032!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;